import Vue from 'vue'

export default {

    computed: {

        $path: function() {

            return this.$route.path

        }

    },

    methods: {

        $filter: function(name, value, args) {

			return this.$options.filters[name](value, args);

		},

        $vueset: function(object, name, value) {

            Vue.set(object, name, value)

        }

    }

}